import React, { useState } from 'react';

import { ModalDelete } from '../modalDelete';
import { IDeleteCellProps } from './interfaces';
import DeleteIcon from '@material-ui/icons/Delete';

export const DeleteCell = ({ row, updateTableData }: IDeleteCellProps) => {
  const [showModalDelete, setShowModalDelete] = useState(false);
  const handleOpenDeleteModal = () => setShowModalDelete(true);
  const handleCloseDeleteModal = () => setShowModalDelete(false);

  return (
    <>
      <ModalDelete
        open={showModalDelete}
        handleClose={handleCloseDeleteModal}
        personId={row.personId}
        returnReceiptId={+row.returnReceiptId}
        updateData={() => updateTableData()}
      />
      <DeleteIcon onClick={() => handleOpenDeleteModal()} style={{ cursor: 'pointer' }} />
    </>
  );
};
